module.exports = __webpack_public_path__ + "media/images/sign-in-background-4e35bfe4bf1e9121fb5c21bf71c0c58e.png";